export default __webpack_public_path__ + "static/bg_image_other@2x-399a5d4e042205ca4710c90e9a872740.webp";